import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RequireApproval = () => {
  const { userData, loading } = useAuth();

  if (loading) return null;

  // 관리자 생성 계정(loginId)은 승인 불요
  if (userData?.status !== 'approved' && !userData?.loginId) {
    return <Navigate to="/pending" replace />;
  }

  return <Outlet />;
};

export default RequireApproval;
